import { useSgTermsAcceptance } from 'common/hooks/useSgTermsAcceptance';
import { PageLoader } from 'components/PageLoader';
import { SgTermsPage } from 'pages';
import { FC, PropsWithChildren } from 'react';

import styles from './SgTermsGuard.module.less';

/**
 * Providers migrated from EU to the Vietnam ERP must accept SG Terms & NDA
 * before they can access any other page. This guard sits above every
 * authenticated route and renders the terms page in place until accepted,
 * without touching the URL.
 */
export const SgTermsGuard: FC<PropsWithChildren> = ({ children }) => {
  const { loading, needsSgTermsAcceptance } = useSgTermsAcceptance();

  if (loading) {
    return (
      <div className={styles.loaderContainer}>
        <PageLoader />
      </div>
    );
  }

  if (needsSgTermsAcceptance) {
    return <SgTermsPage />;
  }

  return <>{children}</>;
};
